export function getAuthRedirectUrl(path = "/nadzorna-plosca"): string {
  if (typeof window === "undefined") {
    return path;
  }
  return `${window.location.origin}${path}`;
}
